/**
 * Get login url
 *
 * @param redirectUrl - Optional URL to redirect to after login
 * @returns {string} Clever login gateway url
 */
const getLoginUrl = (redirectUrl?: string): string => {
  const env =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';

  let baseUrl: string;
  if (env === 'production') {
    baseUrl = 'https://login.listwithclever.com/';
  } else if (env === 'staging') {
    baseUrl = 'https://login-staging.listwithclever.com/';
  } else {
    baseUrl = 'http://localhost:3001/';
  }

  if (redirectUrl) {
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    return `${baseUrl}?redirectUrl=${encodedRedirectUrl}`;
  }

  return baseUrl;
};

export default getLoginUrl;
